module.exports = __webpack_public_path__ + "img/banner_left.b1735bd6.png";